import { Platform } from "../constants";

import { SetupSection } from "./components/setup-section";
import { OrderedList } from "./components/styled";
import { URLVerification, UtmParamsClipboard } from "./components/utms";
import { type PlatformDetails } from "./platform-details";
import { UtmSpendAdditionalDetails } from "./utm-spend-details";

const PLATFORM = Platform.PARTNERIZE;

export const PartnerizeDetails: PlatformDetails = {
  northbeamDocUrl: "",
  officialDocUrl: "",
  additionalDetails: UtmSpendAdditionalDetails(PLATFORM),
};

export const PartnerizeSetup = () => (
  <>
    <SetupSection title="Follow these steps to automatically update UTM parameters for your program">
      <div className="flex flex-col gap-4">
        <OrderedList variant="upper-alpha" className="m-0">
          <>
            Click on the ’Generic Link’ in the creative drop-down menu in the
            program interface.
          </>
          <>
            Paste the parameters below into the ’Destination URL Parameters’
            box.
          </>
          <>Click ’save’.</>
        </OrderedList>
        <UtmParamsClipboard platform={PLATFORM} />
      </div>
    </SetupSection>
    <URLVerification platform={PLATFORM} />
  </>
);
